<template>
    <div>
        <!-- <topSearch></topSearch> -->
        <!-- <breadcrumb></breadcrumb> -->

        <div class="top-title-content">
            <span class="title">수업관리</span>
            <span class="txt">이용권 결제, 수정, 삭제, 환불신청을 할 수 있고, 만료회원 정보를 확인할 수 있습니다.</span>
        </div>

        <div class="com-search-content">
            <div class="line">
                <div class="com-radio">
                    <input
                        id="radio-day-1"
                        :checked="checkType == 'C'"
                        name="radio-day"
                        type="radio"
                        @click="searchRadio('C')"
                    />
                    <label class="w110" for="radio-day-1">등록일 조회</label>
                </div>
                <div class="com-calendar-wrap">
                    <single-calendar :start-date="startDate" @update="startDateUpdate"></single-calendar>
                    <div class="com-dash"><span class="dash">~</span></div>
                    <single-calendar :end-date="endDate" @update="endDateUpdate"></single-calendar>
                </div>
                <select-form
                    :select-data="['오늘', '어제', '이번 달', '지난 달', '3개월', '6개월', '12개월']"
                    :select-value="['today', 'yesterday', 'thisMonth', 'prevMonth', 'threeMonth', 'sixMonth', 'year']"
                    :selected-value="period"
                    @update:set="(val) => periodc(val)"
                ></select-form>
                <div class="com-search-input">
                    <input
                        v-model="searchStr"
                        placeholder="회원명, 연락처('-'제외)"
                        type="text"
                        v-on:keyup.enter="onEventSearch"
                    />
                    <button class="search-btn" @click="onEventSearch">검색</button>
                </div>
            </div>
            <div class="line">
                <div class="com-radio">
                    <input
                        id="radio-day-2"
                        :checked="checkType == 'E'"
                        name="radio-day"
                        type="radio"
                        @click="searchRadio('E')"
                    />
                    <label class="w110" for="radio-day-2">만료일 조회</label>
                </div>
                <div class="com-calendar-wrap">
                    <single-calendar :start-date="expireStartDt" @update="expStartDateUpdate"></single-calendar>
                    <div class="com-dash"><span class="dash">~</span></div>
                    <single-calendar :end-date="expireEndDt" @update="expEndDateUpdate"></single-calendar>
                </div>
                <select-form
                    :select-data="['오늘', '만료 1일 전', '만료 3일 전', '만료 7일 전', '이번 달', '지난 달']"
                    :select-value="['today', '1', '3', '7', 'thisMonth', 'prevMonth']"
                    :selected-value="periodExp"
                    @update:set="(val) => periodExpc(val)"
                ></select-form>
            </div>
            <div class="line">
                <div class='w120 label-tooltip'>
                    <label>잔여횟수</label>
                    <div class="com-tooltip">
                        <div class="icon"></div>
                        <div class="detail">
                            <span class="tit">잔여횟수 조회</span>
                            <p class="txt">
                                이용권 중 총 횟수가 정해져 있는 이용권만 조회 가능합니다. 패키지 이용권은 개별적으로 확인 해
                                주세요.
                            </p>
                        </div>
                    </div>
                </div>

                <div class='input-group'>
                    <input
                        class='form-control'
                        type="text"
                        v-model="times"
                        placeholder="전체"
                        maxlength='3'
                        v-on:keyup.enter="onSearchFirstPage"
                    />

                    <div class='input-group-append'>
                        <span class='input-group-text'>회 이하</span>
                    </div>
                </div>

                <label class='remain-days'>잔여일수</label>

                <div class='input-group'>
                    <input
                        class='form-control'
                        type="text"
                        v-model="remainDays"
                        placeholder="전체"
                        maxlength='3'
                        v-on:keyup.enter="onSearchFirstPage"
                    />

                    <div class='input-group-append'>
                        <span class='input-group-text'>일 이하</span>
                    </div>
                </div>

                <button class="btn btn-secondary" @click="onSearchFirstPage">조회</button>
            </div>
            <div class="line">
                <select-form :select-data="['센터명']"></select-form>
                <select-form
                    :select-data="['이용권 구분', '개인', 'OT', '듀엣', '그룹', '쿠폰', '회원권', '운동복']"
                    :select-value="['', 'P', 'O', 'D', 'G', 'C', 'T', 'S']"
                    :selected-value="ticketType"
                    @update:set="(val) => ticketTypec(val)"
                ></select-form>
                <select-form
                    :select-data="['유효여부', '유효', '만료']"
                    :select-value="['', 'V', 'N']"
                    :selected-value="validTicketType"
                    @update:set="(val) => validTicketTypec(val)"
                ></select-form>
                <select-form
                    :select-data="['이용권명', ...prodList]"
                    :select-value="['', ...prodValList]"
                    :selected-value="prod"
                    class="w240"
                    @update:set="(val) => prodc(val)"
                ></select-form>
                <select-form
                    :select-data="['카테고리명', ...categoryList]"
                    :select-value="['', ...categoryValList]"
                    :selected-value="category"
                    @update:set="(val) => categoryc(val)"
                ></select-form>
                <select-form
                    :select-data="['결제수단', '카드', '현금', '계좌이체', '마일리지', '키오스크', '기타']"
                    :select-value="['', 'C', 'L', 'B', 'M', 'K', 'E']"
                    :selected-value="payType"
                    @update:set="(val) => payTypec(val)"
                ></select-form>
                <select-form
                    :select-data="['등록구분', '신규', '재등록']"
                    :select-value="['', 'N', 'R']"
                    :selected-value="lessStaffContractType"
                    @update:set="(val) => lessStaffContractTypec(val)"
                ></select-form>
                <select-form
                    :disabled="
                        isDisableSelectStaffs ||
                        (this.allowedMenuEvent.eventCds != null &&
                            !this.allowedMenuEvent.eventCds.includes('SC_EVENT_007'))
                    "
                    :select-data="['강사명', ...teacherList]"
                    :select-value="['', ...teacherValueList]"
                    :selected-value="teacherStaff"
                    @update:set="(val) => teacherStaffc(val)"
                ></select-form>
                <button class="com-search-reset" @click="resetSearchContent"></button>
            </div>
        </div>

        <div class="com-table-content">
            <div class="com-btn-area">
                <div class="left-box">
                    <button class="com-btn excel" @click="excelDownload">엑셀 다운로드</button>
                </div>
                <div class="right-box">
                    <span class="txt">
                        총
                        <span class="blue">{{ totalItems }}</span>
                        건
                    </span>
                    &nbsp;&nbsp;&nbsp;
                    <!-- <a href="#" class="com-btn blue">이용권 결제</a> -->
                    <button
                        class="com-btn blue"
                        @click="checkAllowedClick('LE', 1, () => $router.push(`/madmin/course/account/${centerId}`))"
                    >
                        <!-- <router-link :to="{ path: `/madmin/course/account/${this.centerId}` }" class="com-btn blue">이용권 결제</router-link> -->
                        <a class="com-btn blue" href="#">이용권 결제</a>
                    </button>
                </div>
            </div>
            <loading-spinner v-if="isLoading"></loading-spinner>
            <table v-else class="com-table">
                <colgroup>
                    <col style="width: 35px" />
                    <col style="width: 110px" />
                    <col style="width: 160px" />
                    <col style="width: 395px" />
                    <col style="width: 160px" />
                    <col style="width: 110px" v-if="isAllowed('SA', 6)" />
                    <col style="width: 140px" v-if="isAllowed('SA', 6)" />
                    <col style="width: 120px" />
                    <col style="width: 90px" />
                    <col style="width: 90px" />
                    <col style="width: 130px" />
                </colgroup>
                <thead>
                    <tr>
                        <th>
                            <div class="com-check">
                                <input id="check-1-1" v-model="selectAll" name="check-1" type="checkbox" @click="all" />
                                <label for="check-1-1"></label>
                            </div>
                        </th>
                        <th>회원명</th>
                        <th>유효기간</th>
                        <th>이용권명</th>
                        <th>이용권 현황</th>
                        <th v-if="isAllowed('SA', 6)">구매가</th>
                        <th v-if="isAllowed('SA', 6)">결제정보</th>
                        <th>등록구분</th>
                        <th>담당강사</th>
                        <th>등록일자</th>
                        <th>센터명</th>
                    </tr>
                </thead>
                <tbody>
                    <tr v-for="(item, index) in workList" :key="index">
                        <td>
                            <div class="com-check">
                                <input
                                    :id="`check-user-${index}`"
                                    v-model="checkUser"
                                    :value="item"
                                    name="check-1"
                                    type="checkbox"
                                />
                                <label :for="`check-user-${index}`"></label>
                            </div>
                        </td>
                        <td>
                            <span class="info-line">
                                <router-link
                                    :to="{
                                        path: `/madmin/member/payment/${item.cc_center_id}`,
                                        query: { customerId: item.cc_center_cust_id },
                                    }"
                                    class="link"
                                >
                                    {{ item.cc_customer_name }}
                                </router-link>
                                <span>{{ item.cc_customer_phone | customerPhoneFilter }}</span>
                            </span>
                        </td>
                        <td>
                            <span v-if="item.cc_prod_type_cd === 'P'" class="info-line"></span>
                            <span v-else class="info-line">
                                <span>
                                    {{ item.cc_exp_start_dt | timestampFilter }} ~
                                    {{ item.cc_exp_end_dt | timestampFilter }}
                                </span>
                                <span v-if="item.cc_diff_day >= 8" class="under black">
                                    {{ item.cc_diff_day }}일 남음
                                </span>
                                <span v-else-if="7 >= item.cc_diff_day && item.cc_diff_day > 0" class="under red">
                                    만료 {{ item.cc_diff_day }}일 전
                                </span>
                                <span v-else-if="item.cc_diff_day === 0" class="under red">당일만료</span>
                                <span v-else-if="item.cc_diff_day < 0" class="under red">기간만료</span>
                            </span>
                        </td>
                        <td class="left">
                            <!-- <span class="ico type-1">[개인]</span><span class="ico type-2">[그룹]</span><span class="ico type-3">[패키지]</span><span class="ico type-4">[회원권]</span><span class="ico type-5">[듀엣]</span><span class="ico type-6">[OT]</span> -->
                            <span v-if="item.cp_ticket_type_cd === 'P'" class="ico type-1">[개인]</span>
                            <span v-if="item.cp_ticket_type_cd === 'G'" class="ico type-2">[그룹]</span>
                            <span v-if="item.cp_ticket_type_cd === 'C'" class="ico type-3">[쿠폰]</span>
                            <span v-if="item.cp_ticket_type_cd === 'T'" class="ico type-4">[회원권]</span>
                            <span v-if="item.cp_ticket_type_cd === 'D'" class="ico type-5">[듀엣]</span>
                            <span v-if="item.cp_ticket_type_cd === 'O'" class="ico type-6">[OT]</span>
                            <span v-if="item.cp_ticket_type_cd === 'S'" class="ico type-8">[운동복]</span>
                            <span v-if="item.cc_prod_type_cd === 'P'" class="ico type-7">[패키지]</span>
                            <router-link
                                :to="{
                                    path: `/madmin/member/account/${centerId}`,
                                    query: {
                                        customerId: item.cc_center_cust_id,
                                        contractId: item.cc_center_contract_id,
                                        allowedCount: item.resv_total_cnt,
                                    },
                                }"
                            >
                                {{ item.cc_lesson_name }}
                            </router-link>
                        </td>
                        <td>
                            <span class="info-line">
                                <span v-if="item.cc_prod_type_cd === 'P'">
                                    <span class="red">상세보기 &gt;</span>
                                </span>
                                <span v-else-if="item.ccp_less_cnt_type_cd === 'U' && item.cp_ticket_type_cd === 'T'">
                                    <!--무제한인 경우-->
                                    <span class="red">{{ item.attendance_cnt == null ? 0 : item.attendance_cnt }}</span>
                                    /무제한
                                </span>
                                <span v-else-if="item.ccp_less_cnt_type_cd === 'U' && item.cp_ticket_type_cd !== 'T'">
                                    <!--무제한인 경우-->
                                    <span class="red">{{ item.resv_total_cnt == null ? 0 : item.resv_total_cnt }}</span>
                                    /무제한 (출석
                                    <span class="red">
                                        {{ item.cc_less_join_cnt != null ? item.cc_less_join_cnt : 0 }}
                                    </span>
                                    / 결석
                                    <span class="red">
                                        {{ item.cc_less_absn_cnt != null ? item.cc_less_absn_cnt : 0 }}
                                    </span>
                                    )
                                </span>
                                <span v-else-if="item.ccp_less_cnt_type_cd === 'W'">
                                    <!--횟수가 존재-->
                                    <span class="red">{{ item.resv_total_cnt == null ? 0 : item.resv_total_cnt }}</span>
                                    /주{{ item.cc_less_cnt }} 회 (출석
                                    <span class="red">
                                        {{ item.cc_less_join_cnt != null ? item.cc_less_join_cnt : 0 }}
                                    </span>
                                    / 결석
                                    <span class="red">
                                        {{ item.cc_less_absn_cnt != null ? item.cc_less_absn_cnt : 0 }}
                                    </span>
                                    )
                                </span>
                                <span v-else-if="item.cp_ticket_type_cd === 'T' && item.ccp_less_cnt_type_cd !== 'U'">
                                    <!--회원권이지만 무제한이 아닌경우-->
                                    <span class="red">{{ item.cc_less_join_cnt + item.cc_less_absn_cnt }}</span>
                                    / {{ item.cc_less_cnt }} 회
                                </span>
                                <span v-else>
                                    <!--그외-->
                                    <span class="red">{{ item.resv_total_cnt == null ? 0 : item.resv_total_cnt }}</span>
                                    /{{ item.cc_less_cnt }} 회 (출석
                                    <span class="red">
                                        {{ item.cc_less_join_cnt != null ? item.cc_less_join_cnt : 0 }}
                                    </span>
                                    / 결석
                                    <span class="red">
                                        {{ item.cc_less_absn_cnt != null ? item.cc_less_absn_cnt : 0 }}
                                    </span>
                                    )
                                </span>

                                <span class="center">
                                    <span v-if="item.cp_ticket_type_cd === 'T'">
                                        <router-link
                                            :to="{
                                                path: `/madmin/member/attend/${centerId}`,
                                                query: { customerId: item.cc_center_cust_id },
                                            }"
                                            class="com-btn-small deep-black"
                                        >
                                            스케줄 &gt;
                                        </router-link>
                                    </span>
                                    <span v-else>
                                        <router-link
                                            :to="{
                                                path: `/madmin/course/care/reserve`,
                                                query: {
                                                    customerId: item.cc_center_cust_id,
                                                    contractId: item.cc_center_contract_id,
                                                    centerProductId: item.cp_center_prod_id,
                                                },
                                            }"
                                            class="com-btn-small deep-black"
                                        >
                                            스케줄 &gt;
                                        </router-link>
                                    </span>
                                </span>
                            </span>
                        </td>
                        <td v-if="isAllowed('SA', 6)">{{ item.cc_total_buy_price | numberFormatFilter }} 원</td>
                        <td v-if="isAllowed('SA', 6)">
                            <span v-if="item.cc_ret_yn" class="info-line">
                                <span class="red">환불완료</span>
                            </span>
                            <span v-else class="info-line">
                                <span>{{ convertBill(item.cc_bill_info) }}</span>
                                <!-- <span class="red">[미수금] 200,000 원</span> -->
                                <span v-if="item.cc_total_debt_price != 0" class="red">
                                    [미수금] {{ item.cc_total_debt_price | numberFormatFilter }}원
                                </span>
                            </span>
                        </td>
                        <td v-if="item.cc_prod_type_cd === 'P'"></td>
                        <td v-else>{{ convertContractType(item.ccp_less_staff_contract_type_cd, item.regist_cnt) }}</td>
                        <td>
                            <div v-for="(name, index) in splitName(item.cc_staff_name)" :key="index">
                                {{ name }}
                            </div>
                        </td>
                        <td>{{ item.cc_cre_dt | timestampFilter }}</td>
                        <td>{{ item.cc_center_nm }}</td>
                    </tr>

                    <!--
                <tr>
                    <td>
                        <div class="com-check">
                            <input type="checkbox" name="check-user" id="check-user-1">
                            <label for="check-user-1"></label>
                        </div>
                    </td>
                    <td>
                        <span class="info-line">
                            <span class="blue">홍길동</span>
                            <span>010-0000-0000</span>
                        </span>
                    </td>
                    <td>
                        <span class="info-line">
                            <span>2020-01-01 ~ 2020-01-31</span>
                            <span class="under">154일 남음</span>
                        </span>
                    </td>
                    <td class="left">
                        <span class="ico type-1">[개인]</span><span class="ico type-2">[그룹]</span><span class="ico type-3">[패키지]</span><span class="ico type-4">[회원권]</span><span class="ico type-5">[듀엣]</span><span class="ico type-6">[OT]</span>
                        <a href="#" class="link">필라테스 10회 PL + 개인레스 PL 10회</a>
                    </td>
                    <td>
                        <span class="info-line">
                            <span>
                                <span class="red">8</span>/10 회 (출석 <span class="red">6</span> / 결석 <span class="red">2</span>)
                            </span>
                            <span class="center">
                                <a href="#" class="com-btn-small deep-black">스케줄 &gt;</a>
                            </span>
                        </span>
                    </td>
                    <td>500,000 원</td>
                    <td>
                        <span class="info-line">
                            <span>[카드] 500,000 원</span>
                        </span>
                    </td>
                    <td>신규 1회</td>
                    <td>김윤경<br>김다은</td>
                    <td>2019.08.20</td>
                    <td>핏투데이케어 - 신촌점</td>
                </tr>
                <tr>
                    <td>
                        <div class="com-check">
                            <input type="checkbox" name="check-user" id="check-user-1">
                            <label for="check-user-1"></label>
                        </div>
                    </td>
                    <td>
                        <span class="info-line">
                            <span class="blue">홍길동</span>
                            <span>010-0000-0000</span>
                        </span>
                    </td>
                    <td>
                        <span class="info-line">
                            <span>2020-01-01 ~ 2020-01-31</span>
                            <span class="under">154일 남음</span>
                        </span>
                    </td>
                    <td class="left">
                        <span class="ico type-1">[개인]</span>
                        <a href="#" class="link">필라테스 10회 PL + 개인레스 PL 10회</a>
                    </td>
                    <td>
                        <span class="info-line">
                            <span>
                                <span class="red">상세보기 &gt;</span>
                            </span>
                            <span class="center">
                                <a href="#" class="com-btn-small deep-black">스케줄 &gt;</a>
                            </span>
                        </span>
                    </td>
                    <td>500,000 원</td>
                    <td>
                        <span class="info-line">
                            <span>[계좌] 500,000 원</span>
                            <span class="red">[미수금] 200,000 원</span>
                        </span>
                    </td>
                    <td>신규 1회</td>
                    <td>김윤경</td>
                    <td>2019.08.20</td>
                    <td>핏투데이케어 - 신촌점</td>
                </tr>
                -->
                    <tr v-if="workList.length === 0">
                        <td colspan="100">등록된 내용이 없습니다.</td>
                    </tr>
                </tbody>
            </table>
            <div class="sort-bottom-area">
                <button
                    v-if="hasMessageEvent"
                    class="com-btn deep-blue left"
                    @click="routing('messageSend', checkUser)"
                >
                    메시지 발송
                </button>
                <select-form
                    :select-data="[...sortTypeList]"
                    :select-value="[...sortTypeValueList]"
                    class="float-right"
                    @update:set="changeLimit"
                ></select-form>
            </div>
            <!-- <b-pagination
                v-if="hasBack"
                aria-controls="my-table"
                align="center"
                first-class="first"
                prev-class="prev"
                next-class="next"
                last-class="last"
                v-model="previousPagingInfo.page"
                :total-rows="previousPagingInfo.totalItems"
                :per-page="previousPagingInfo.limit"
                @change="handlerPagenation($event)"
            /> -->
            <b-pagination
                v-if='!isLoading'
                v-model="pagingInfo.page"
                :per-page="pagingInfo.limit"
                :total-rows="pagingInfo.totalItems"
                align="center"
                aria-controls="my-table"
                first-class="first"
                last-class="last"
                next-class="next"
                prev-class="prev"
                @change="handlerPagenation($event)"
            />
        </div>
    </div>
</template>

<script>
import { maskCustomerPhone } from '@/assets/js/customerPhone';
import api from '@/assets/js/api';
import moment from 'moment';
import { Utils } from '@/assets/js/utils';
import { MixinAllowedMenu } from '@/assets/js/mixinAllowedMenu';
import XLSX from 'xlsx';
import { timestampToDate } from '@/assets/js/excelCommon.js';
import EventBus from '../../../assets/js/eventBus';
import { pagingInfo } from '@/assets/js/common';
export default {
    name: 'CourseCare',
    mixins: [MixinAllowedMenu],
    props: {},
    computed: {
        isDisableSelectStaffs() {
            // return !this.isAllowed('SC', 1);
            return false;
        },
    },
    watch: {},
    data() {
        return {
            centerId: this.$store.state.auth.user.centerId, // Vuex Store 사용 문법
            centerStaffId: this.$store.state.auth.user.uid, // uid가 centerStaffId
            isLoading: false,
            workList: [],
            searchStr: '',
            searchType: '',
            sortTypeList: [...this.$sortType],
            sortTypeValueList: [...this.$sortTypeValue],
            pagingInfo: { ...pagingInfo },
            prevPagingStep: this.$route.query.prevPagingStep,
            checkUser: [],
            selectAll: false,
            startDate: '',
            endDate: '',
            expireStartDt: '',
            expireEndDt: '',
            period: 'year', // 등록일 조회
            periodExp: 'thisMonth', // 만료일 조회
            validTicketType: '', // 유효여부
            ticketType: '', // 이용권 유효코드
            payType: '', // 결제유형
            lessStaffContractType: '', // 계약유형
            category: '', // 카테고리값
            totalItems: '',
            categoryList: [],
            categoryValList: [],

            prodList: [],
            prodValList: [],
            prod: '',
            teacherStaff: '',
            teacherList: [], // 강사 직원
            teacherValueList: [],
            checkType: 'C', // 기본값 C
            times: '', // 횟수
            remainDays: this.$route.query.remainDays, // 잔여일수
            isLast: false, // 체크박스 전체 선택 및 해제 시에 필요한 설정값
            hasMessageEvent: false, // 메시지 계약되었을시..
            // 페이징 리스트 감췄다 보여주기 위한 변수..
            hasBack: false,
            count: 0,
            first: 4,
        };
    },
    async mounted() {
        await this.allowedMenuEvent.init();
        this.checkMessageEvent();
        this.settingForPreviousPage(localStorage.getItem('previousPath'));
    },
    methods: {
        periodc(newValue) {
            this.period = newValue;
            if (newValue === 'thisMonth') {
                this.startDate = moment().startOf('month').format('YYYY-MM-DD');
                this.endDate = moment().endOf('month').format('YYYY-MM-DD');
            } else if (newValue === 'prevMonth') {
                this.startDate = moment().subtract(1, 'months').startOf('month').format('YYYY-MM-DD');
                this.endDate = moment().subtract(1, 'months').endOf('month').format('YYYY-MM-DD');
            } else if (newValue === 'today') {
                this.startDate = moment().format('YYYY-MM-DD');
                this.endDate = moment().format('YYYY-MM-DD');
            } else if (newValue === 'yesterday') {
                this.startDate = moment().subtract(1, 'days').format('YYYY-MM-DD');
                this.endDate = moment().subtract(1, 'days').format('YYYY-MM-DD');
            } else if (newValue === 'lastWeek') {
                this.startDate = moment().subtract(7, 'days').format('YYYY-MM-DD');
                this.endDate = moment().format('YYYY-MM-DD');
            } else if (newValue === 'threeMonth') {
                this.startDate = moment().subtract(3, 'months').format('YYYY-MM-DD');
                this.endDate = moment().format('YYYY-MM-DD');
            } else if (newValue === 'sixMonth') {
                this.startDate = moment().subtract(6, 'months').format('YYYY-MM-DD');
                this.endDate = moment().format('YYYY-MM-DD');
            } else if (newValue === 'year') {
                this.startDate = moment().subtract(12, 'months').format('YYYY-MM-DD');
                this.endDate = moment().format('YYYY-MM-DD');
            }
            this.onSearchFirstPage();
        },
        periodExpc(newValue) {
            this.periodExp = newValue;
            if (newValue === 'thisMonth') {
                this.expireStartDt = moment().startOf('month').format('YYYY-MM-DD');
                this.expireEndDt = moment().endOf('month').format('YYYY-MM-DD');
            } else if (newValue === 'prevMonth') {
                this.expireStartDt = moment().subtract(1, 'months').startOf('month').format('YYYY-MM-DD');
                this.expireEndDt = moment().subtract(1, 'months').endOf('month').format('YYYY-MM-DD');
            } else if (newValue === 'today') {
                this.expireStartDt = moment().format('YYYY-MM-DD');
                this.expireEndDt = moment().format('YYYY-MM-DD');
            } else if (newValue === '1') {
                this.expireStartDt = moment().format('YYYY-MM-DD');
                this.expireEndDt = moment().add(1, 'days').format('YYYY-MM-DD');
            } else if (newValue === '3') {
                this.expireStartDt = moment().format('YYYY-MM-DD');
                this.expireEndDt = moment().add(2, 'days').format('YYYY-MM-DD');
            } else if (newValue === '7') {
                this.expireStartDt = moment().format('YYYY-MM-DD');
                this.expireEndDt = moment().add(6, 'days').format('YYYY-MM-DD');
            }
            this.onSearchFirstPage();
        },
        startDatec(newValue) {
            this.startDate = newValue;
            this.onSearchFirstPage();
        },
        endDatec(newValue) {
            this.endDate = newValue;
            this.onSearchFirstPage();
        },
        validTicketTypec(newValue) {
            this.validTicketType = newValue;
            this.onSearchFirstPage();
        },
        ticketTypec(newValue) {
            this.ticketType = newValue;
            this.onSearchFirstPage();
        },
        payTypec(newValue) {
            this.payType = newValue;
            this.onSearchFirstPage();
        },
        lessStaffContractTypec(newValue) {
            this.lessStaffContractType = newValue;
            this.onSearchFirstPage();
        },
        categoryc(newValue) {
            this.category = newValue;
            this.onSearchFirstPage();
        },
        prodc(newValue) {
            this.prod = newValue;
            this.onSearchFirstPage();
        },
        teacherStaffc(newValue) {
            this.teacherStaff = newValue;
            this.onSearchFirstPage();
        },
        timesc(newValue) {
            this.times = newValue;
            this.onSearchFirstPage();
        },

        init() {
            try {
                Promise.allSettled([
                    this.onFetchTeachers(),
                    this.onCategoryList(),
                    this.onProductList(),
                    this.onSearchList(),
                ]);
                // 카테고리 리스트
                // 이용권리스트
            } catch (error) {
                console.log(error);
            }
        },

        settingForPreviousPage(path) {
            const searchCondition = JSON.parse(localStorage.getItem('searchCondition'));
            if (path && (path.endsWith('care/reserve') || path.includes('member/payment') || path.includes('member/account')) && searchCondition) {
                this.pagingInfo.page = searchCondition.page;
                this.pagingInfo.limit = searchCondition.limit;
                this.pagingInfo.totalItems = searchCondition.totalItems;
                this.checkType = searchCondition.checkType;
                this.startDate = this.changeDateBeforesettingForPreviousPage(searchCondition.createStartDate, 0);
                this.endDate = this.changeDateBeforesettingForPreviousPage(searchCondition.createEndDate, 1);
                this.searchStr = searchCondition.searchStr;
                this.expireStartDt = this.changeDateBeforesettingForPreviousPage(searchCondition.expireStartDt, 2);
                this.expireEndDt = this.changeDateBeforesettingForPreviousPage(searchCondition.expireEndDt, 3);
                this.times = searchCondition.lessonRemainCount;
                this.remainDays = searchCondition.lessonRemainDays;
                this.ticketType = searchCondition.ticketType;
                this.validTicketType = searchCondition.validTicketType;
                this.prod = searchCondition.centerProductId;
                this.category = searchCondition.centerProductCategoryTemplateId;
                this.payType = searchCondition.payType;
                this.lessStaffContractType = searchCondition.lessStaffContractType;
                this.teacherStaff = searchCondition.centerStaffId;
                // 강사명 조회 값 넣기.
                // 카테고리 리스트
                // 이용권리스트
                // 회원 목록 가져오기
                Promise.allSettled([
                    this.onFetchTeachers(),
                    this.onCategoryList(),
                    this.onProductList(),
                    this.onSearchList(),
                ]);
                this.hasBack = true;
            } else {
                this.startDate = this.initStartDate();
                this.endDate = this.initEndDate();
                this.checkType = this.$route.query.value ? this.$route.query.value : 'C';
                this.expireStartDt = this.$route.query.ExpStartDate
                    ? this.$route.query.ExpStartDate
                    : this.initStartDate();
                this.expireEndDt = this.$route.query.ExpEndDate ? this.$route.query.ExpEndDate : this.initEndDate();
                this.pagingInfo.page = 1;
                this.pagingInfo.limit = 10;
                // 모든 이용권의 예약 권한 적용(SC_EVENT_007)
                if (
                    this.allowedMenuEvent.eventCds != null &&
                    !this.allowedMenuEvent.eventCds.includes('SC_EVENT_007')
                ) {
                    this.teacherStaff = parseInt(this.$store.getters['auth/staffId']);
                }
                this.init();
            }
        },

        changeDateBeforesettingForPreviousPage(val, num) {
            if (num === 0) {
                if (val === '') {
                    return this.initStartDate();
                }
                return moment(val).format('YYYY-MM-DD');
            } else if (num === 1) {
                if (val === '') {
                    return this.initEndDate();
                }
                return moment(val).format('YYYY-MM-DD');
            } else if (num === 2) {
                if (val === '') {
                    return moment().startOf('month').format('YYYY-MM-DD');
                }
                return moment(val).format('YYYY-MM-DD');
            } else if (num === 3) {
                if (val === '') {
                    return moment().endOf('month').format('YYYY-MM-DD');
                }
                return moment(val).format('YYYY-MM-DD');
            }
        },

        onSearchFirstPage() {
            this.pagingInfo.page = 1;
            this.onSearchList();
        },
        async onSearchList() {
            try {
                this.isLoading = true;
                const { data } = await this.getWorkList();

                this.setPageParams(data);
                this.workList = data.items;
                this.totalItems = data.meta.totalItems;
                this.isLoading = false;
            } catch (error) {
                this.isLoading = false;
                console.log(error);
            }
        },
        getWorkList() {
            // 스웨거: 수업관리 페이징 목록 조회
            const params = {
                searchStr: this.searchStr,
                createStartDate: this.checkType === 'C' ? moment(this.startDate).format('YYYYMMDD') : '',
                createEndDate: this.checkType === 'C' ? moment(this.endDate).format('YYYYMMDD') : '',
                expireStartDt: this.checkType === 'E' ? moment(this.expireStartDt).format('YYYYMMDD') : '',
                expireEndDt: this.checkType === 'E' ? moment(this.expireEndDt).format('YYYYMMDD') : '',
                validTicketType: this.validTicketType, // 유효여부 값
                ticketType: this.ticketType, // 이용권 유형코드
                lessStaffContractType: this.lessStaffContractType, // 계약유형
                centerStaffId: this.teacherStaff,
                centerProductCategoryTemplateId: this.category,
                centerProductId: this.prod,
                lessonRemainCount: this.times,
                lessonRemainDays: this.remainDays,
                payType: this.payType,
                ...this.pagingInfo,
            };
            const searchCondition = params;
            searchCondition.checkType = this.checkType;
            localStorage.setItem('searchCondition', JSON.stringify(searchCondition));
            return api.get(`/admin/api/center/${this.centerId}/lesson`, {
                params,
            });
        },

        // 검색어 입력 처리
        onEventSearch(e) {
            if (this.searchStr.length > 0 && this.searchStr.length < 2) {
                return;
            }
            this.pagingInfo.page = 1;
            this.onSearchList();
        },

        // 검색 조건 초기화
        resetSearchContent() {
            this.times = '';
            this.remainDays = '';

            this.ticketType = '';
            this.validTicketType = '';
            this.prod = '';
            this.category = '';
            this.payType = '';
            this.lessStaffContractType = '';
            // 모든 이용권의 예약 권한 적용(SC_EVENT_007)
            if (this.allowedMenuEvent.eventCds != null && !this.allowedMenuEvent.eventCds.includes('SC_EVENT_007')) {
                this.teacherStaff = parseInt(this.$store.getters['auth/staffId']);
            } else {
                this.teacherStaff = '';
            }
            this.searchType = '';

            this.onSearchFirstPage();

            EventBus.$emit('event:initList', 'init');
        },

        setPageParams(data) {
            this.pagingInfo.totalPages = data.meta.totalPages;
            this.pagingInfo.page = data.meta.currentPage;
            this.pagingInfo.totalItems = data.meta.totalItems;
            this.pagingInfo.itemCount = data.meta.itemCount;
        },

        // 페이징 이벤트
        async handlerPagenation(event) {
            this.pagingInfo.page = event;
            await this.onSearchList();

            const checkList = this.checkSelectAll(this.checkUser, this.workList);
            if (checkList === this.pagingInfo.limit) {
                this.selectAll = true;
            } else {
                this.selectAll = false;
            }
        },

        checkSelectAll(checkList, customerList) {
            let answer = 0;
            for (let i = 0; i < checkList.length; i++) {
                for (let j = 0; j < customerList.length; j++) {
                    if (checkList[i].cc_center_contract_id === customerList[j].cc_center_contract_id) {
                        answer += 1;
                    }
                }
            }
            return answer;
        },

        // 한 페이지에 표시되는 줄 수 변경
        changeLimit(val) {
            this.pagingInfo.limit = val;
            this.onSearchList();
        },

        // 리스트 삭제하기
        async onDeleteList(centerTaskId) {
            try {
                const data = await this.deleteList(centerTaskId);
                // console.log('===> Success List Delete', data);
                this.onSearchList();
            } catch (error) {
                console.log(error);
                alert('오류가 발생했습니다.');
            }
        },
        deleteList(centerTaskId) {
            return api.delete(`/admin/api/centerTask/delete/${this.centerId}/${centerTaskId}`);
        },

        // 이름 배열화
        splitName(value) {
            if (!value) return '';

            return value.split('|');
        },
        // 전체선택 버튼
        all() {
            const checkBoxArray = document.getElementsByName('check-1');
            const allCheckBox = document.getElementsByName('check-1')[0];
            const checkBoxLength = checkBoxArray.length;
            if (this.isLast) {
                this.isLast = false;
                return;
            }

            for (let i = 1; i < checkBoxLength; i++) {
                if (allCheckBox.checked === true && checkBoxArray[i].checked === false) {
                    checkBoxArray[i].click();
                } else if (allCheckBox.checked === false && checkBoxArray[i].checked === true) {
                    checkBoxArray[i].click();
                }
            }
        },
        // 검색 종료일
        initEndDate() {
            const endDate = moment().format('YYYY-MM-DD');
            return endDate;
        },

        // 검색 시작일
        initStartDate() {
            const startDate = moment().subtract(12, 'months').format('YYYY-MM-DD');
            return startDate;
        },

        // 검색 시작일 변경 event
        startDateUpdate(val) {
            this.startDate = val;
            this.pagingInfo.page = 1;
            this.onSearchList();
        },

        // 검색 종료일 변경 event
        endDateUpdate(val) {
            this.endDate = val;
            this.pagingInfo.page = 1;
            this.onSearchList();
        },
        // 유효기간 검색 시작일 변경 event
        expStartDateUpdate(val) {
            this.expireStartDt = val;
            this.pagingInfo.page = 1;
            this.onSearchList();
        },

        // 유효기간 검색 종료일 변경 event
        expEndDateUpdate(val) {
            this.expireEndDt = val;
            this.pagingInfo.page = 1;
            this.onSearchList();
        },
        // 결제정보 컨버팅
        convertBill(bill) {
            if (bill === null || bill === '' || bill === undefined) {
                return bill;
            }
            const a = bill.split('|');
            const data = [];
            for (const e of a) {
                const b = e.split('_');
                data.push({
                    type: b[0],
                    amount: parseInt(b[1], 10),
                });
            }

            let sum = {};
            let type = '';
            for (const c of data) {
                if (sum.type === undefined) {
                    sum = c;
                } else {
                    sum.amount += c.amount;
                }
            }

            if (sum.type === 'C') {
                type = '[카드]';
            } else if (sum.type === 'L') {
                type = '[현금]';
            } else if (sum.type === 'B') {
                type = '[계좌이체]';
            } else if (sum.type === 'M') {
                type = '[마일리지]';
            } else if (sum.type === 'E') {
                type = '[기타]';
            } else if (sum.type === 'T' || sum.type === 'U') {
                type = '[핏페이]';
            } else if (sum.type === 'K') {
                type = '[키오스크]';
            }

            const result = `${type} ${Utils.getNumberFormat(sum.amount)}원`;
            return result;
        },
        // 계약유형
        convertContractType(val, regisCnt) {
            if (val === 'N') {
                return '신규';
            } else if (val === 'R') {
                return `재등록 ${regisCnt} 회`;
            } else if (val === 'C') {
                return '환불';
            }
        },
        /*
        //이용권결제 클릭시
        async payTicket(){
            //체크된 row 값 찾아서 넣어주기
            console.log(this.checkUser);
            if(this.checkUser == ''){
                alert('이용권을 체크 해주세요.')
                return false;
            }else if(this.checkUser.length > 1){ //여러개 선택시
                alert('이용권 결제는 하나씩 가능합니다.')
            }else{//하나만 체크했을경우 진행
            const { data } = await this.getWorkList(); //데이터 조회
            console.log('check',data.items[this.checkUser]);
            this.customerId = data.items[this.checkUser].cc_center_cust_id;
            this.contractId = data.items[this.checkUser].cc_center_contract_id;
            this.$router.push({ path : `/madmin/course/care/edit/${this.centerId}`, query: { customerId: this.customerId, contractId: this.contractId } });
            }
        },
         */
        // 카테고리명 조회
        async onCategoryList() {
            try {
                const { data } = await this.getCategoryList();
                console.log(data);
                data.forEach((g) => {
                    this.categoryList.push(g.name);
                    this.categoryValList.push(g.centerProductCategoryTemplateId);
                });
            } catch (error) {
                console.log(error);
                console.log('카테고리 값을 가져오는데 실패했습니다.');
            }
        },
        getCategoryList() {
            return api.get(`/admin/api/center/${this.centerId}/product/category/template`);
        },
        // 이용권명 조회
        async onProductList() {
            try {
                const { data } = await this.getProductListAll();
                console.log('이용권명', data);
                data.forEach((g) => {
                    if (g.productType === 'T') {
                        this.prodList.push(
                            `[${
                                {
                                    P: '개인',
                                    G: '그룹',
                                    C: '쿠폰',
                                    T: '회원권',
                                    D: '듀엣',
                                    O: 'OT',
                                    S: '운동복',
                                }[g.ticketType]
                            }] ${g.name}`
                        );
                        this.prodValList.push(g.centerProductId);
                    }
                });
            } catch (error) {
                console.log(error);
                console.log('error');
            }
        },
        // 이용권명 조회 API
        getProductListAll() {
            return api.get(`/admin/api/center/${this.centerId}/product/ticket/all`);
        },
        // getProductList(){
        //     return api.get(`/admin/api/center/${this.centerId}/product/ticket`,{
        //     params:{
        //         ...this.pagingInfo,
        //     }})
        // },
        // 강사 리스트 조회
        async onFetchTeachers() {
            try {
                const { data } = await this.getFetchTeachers();
                data.sort((a, b) =>
                    // order by 정렬
                    a.name < b.name ? -1 : a.name > b.name ? 1 : 0
                );
                console.log('강사 리스트', data);
                data.forEach((g) => {
                    this.teacherList.push(g.name);
                    this.teacherValueList.push(g.centerStaffId);
                });
            } catch (error) {
                console.log(error);
                console.log('에러입니다.');
            }
        },
        // 강사 리스트 조회 api
        getFetchTeachers() {
            return api.get(`/admin/api/center/${this.centerId}/staff/teachers/list`);
        },

        // 엑셀 다운로드 기능
        async excelDownload() {
            const { data } = await this.getWorkListExcel(); // 엑셀용 요청값

            const excelDownloadArray = [];
            console.log(data);
            data.items.forEach((member) => {
                const temp = {};
                temp['회원명'] = member.cc_customer_name;
                temp['전화번호'] = maskCustomerPhone(
                    member.cc_customer_phone.replace(/^(\d{2,3})(\d{3,4})(\d{4})$/, '$1-$2-$3')
                );
                temp['유효기간'] = `${timestampToDate(member.cc_exp_start_dt)}~${timestampToDate(
                    member.cc_exp_end_dt
                )}`;
                temp['남은일수'] = this.getRemainDayString(member.cc_diff_day);
                temp['이용권명'] = `[${Utils.getTicketTypeName(member.cp_ticket_type_cd)}]${member.cc_lesson_name}`;
                temp['이용권현황'] = `${ Number(member.cc_less_join_cnt || 0 ) + Number(member.cc_less_absn_cnt || 0) }/${member.cc_less_cnt}`;
                temp['출결현황'] = `출석 ${member.cc_less_join_cnt || 0} / 결석 ${member.cc_less_absn_cnt || 0}`;
                temp['구매가'] = `${member.cc_total_buy_price}원`;
                temp['결제정보'] = `${this.convertBill(member.cc_bill_info)} ${member.cc_total_debt_price}`;
                temp['미수금'] = `${member.cc_total_debt_price || ''}`;
                temp['등록구분'] = this.convertContractType(member.ccp_less_staff_contract_type_cd, member.regist_cnt);
                temp['담당강사'] = member.cc_staff_name;
                temp['매출직원'] = member.cc_sale_staff_name;
                temp['등록일자'] = timestampToDate(member.cc_cre_dt);
                temp['센터명'] = member.cc_center_nm;

                excelDownloadArray.push(temp);
            });

            /* [Key:value, ...] */
            const dataWS = XLSX.utils.json_to_sheet(excelDownloadArray);

            // cell width 설정
            const wscols = [
                { wch: 12 },
                { wch: 15 },
                { wch: 24 },
                { wch: 15 },
                { wch: 50 },
                { wch: 12 },
                { wch: 18 },
                { wch: 18 },
                { wch: 18 },
                { wch: 18 },
                { wch: 12 },
                { wch: 12 },
                { wch: 12 },
                { wch: 12 },
                { wch: 30 },
            ];
            dataWS['!cols'] = wscols;

            // cell height 설정
            const wsrows = [{ hpx: 30 }];
            dataWS['!rows'] = wsrows;

            const wb = XLSX.utils.book_new();

            XLSX.utils.book_append_sheet(wb, dataWS, '수업관리');
            XLSX.writeFile(wb, `수업관리 ${new Date().toLocaleDateString().toString()}.xlsx`);
        },
        searchRadio(parameter) {
            this.checkType = parameter;
            this.init();
        },
        getWorkListExcel() {
            // 스웨거: 수업관리 페이징 목록 조회
            return api.get(`/admin/api/center/${this.centerId}/lesson`, {
                params: {
                    searchStr: this.searchStr,
                    createStartDate: this.checkType === 'C' ? moment(this.startDate).format('YYYYMMDD') : '',
                    createEndDate: this.checkType === 'C' ? moment(this.endDate).format('YYYYMMDD') : '',
                    expireStartDt: this.checkType === 'E' ? moment(this.expireStartDt).format('YYYYMMDD') : '',
                    expireEndDt: this.checkType === 'E' ? moment(this.expireEndDt).format('YYYYMMDD') : '',
                    validTicketType: this.validTicketType, // 유효여부 값
                    ticketType: this.ticketType, // 이용권 유형코드
                    lessStaffContractType: this.lessStaffContractType, // 계약유형
                    centerStaffId: this.teacherStaff,
                    centerProductCategoryTemplateId: this.category,
                    centerProductId: this.prod,
                    lessonRemainCount: this.times,
                    lessonRemainDays: this.remainDays,
                    payType: this.payType,
                    ...this.pagingInfo,
                    limit: 10000,
                },
            });
        },
        getRemainDayString(day) {
            if (day < 7 && day > 0) {
                return `만료 ${day}일 전`;
            }

            if (day === 0) {
                return '당일만료';
            }

            if (day < 0) {
                return '기간만료';
            }

            return `${day}일 남음`;
        },
        routing(toName, checkedUserData) {
            const routingData = [];
            checkedUserData.forEach((param) => {
                const tempValue = {
                    centerCustomerId: param.cc_center_cust_id,
                    name: param.cc_customer_name,
                    phone: param.cc_customer_phone,
                };
                routingData.push(tempValue);
            });
            this.$router.push({
                name: toName,
                params: { data: routingData },
            });
        },
        checkPreviosParam(paramMap) {
            const paramValues = Object.values(paramMap);
            for (const i in paramValues) {
                if (paramValues[i] != '' || paramValues[i].length != 0 || paramValues[i] != 0) {
                    return true;
                }
            }
            return false;
        },
        checkMessageEvent() {
            return api
                .get('/admin/api/center/ftcontract/sms')
                .then((res) => {
                    this.hasMessageEvent = JSON.parse(res.data);
                })
                .catch((error) => {
                    this.hasMessageEvent = false;
                });
        },
    },
};
</script>

<style lang="scss" scoped>
.line label {
    font-size: 14px;
    line-height: 32px;
    color: #808080;
}

.line .input-group {
    width: 150px;
}

.input-group input {
    text-align: right;
}

.label-tooltip {
    display: flex;
    align-items: center;
}

.remain-days {
    margin-left: 64px;
    margin-right: 24px;
}

.line .btn {
    margin-left: 8px;
    min-width: 80px;
    font-size: 15px;
}
</style>
